// Country dial codes with flag emojis.
// Azerbaijan is always first by request — rest are sorted by name (English).
// Source: ITU-T E.164 country codes. Flags are Unicode regional indicator pairs.

export const COUNTRIES = [
  // ── Pinned: Azerbaijan first
  { code: "AZ", name: "Azerbaijan", nameAz: "Azərbaycan", dial: "+994", flag: "🇦🇿" },

  // ── Rest alphabetical (English)
  { code: "AF", name: "Afghanistan", nameAz: "Əfqanıstan", dial: "+93", flag: "🇦🇫" },
  { code: "AL", name: "Albania", nameAz: "Albaniya", dial: "+355", flag: "🇦🇱" },
  { code: "DZ", name: "Algeria", nameAz: "Əlcəzair", dial: "+213", flag: "🇩🇿" },
  { code: "AD", name: "Andorra", nameAz: "Andorra", dial: "+376", flag: "🇦🇩" },
  { code: "AO", name: "Angola", nameAz: "Anqola", dial: "+244", flag: "🇦🇴" },
  { code: "AR", name: "Argentina", nameAz: "Argentina", dial: "+54", flag: "🇦🇷" },
  { code: "AM", name: "Armenia", nameAz: "Ermənistan", dial: "+374", flag: "🇦🇲" },
  { code: "AU", name: "Australia", nameAz: "Avstraliya", dial: "+61", flag: "🇦🇺" },
  { code: "AT", name: "Austria", nameAz: "Avstriya", dial: "+43", flag: "🇦🇹" },
  { code: "BH", name: "Bahrain", nameAz: "Bəhreyn", dial: "+973", flag: "🇧🇭" },
  { code: "BD", name: "Bangladesh", nameAz: "Banqladeş", dial: "+880", flag: "🇧🇩" },
  { code: "BY", name: "Belarus", nameAz: "Belarus", dial: "+375", flag: "🇧🇾" },
  { code: "BE", name: "Belgium", nameAz: "Belçika", dial: "+32", flag: "🇧🇪" },
  { code: "BO", name: "Bolivia", nameAz: "Boliviya", dial: "+591", flag: "🇧🇴" },
  { code: "BA", name: "Bosnia and Herzegovina", nameAz: "Bosniya və Herseqovina", dial: "+387", flag: "🇧🇦" },
  { code: "BR", name: "Brazil", nameAz: "Braziliya", dial: "+55", flag: "🇧🇷" },
  { code: "BG", name: "Bulgaria", nameAz: "Bolqarıstan", dial: "+359", flag: "🇧🇬" },
  { code: "KH", name: "Cambodia", nameAz: "Kamboca", dial: "+855", flag: "🇰🇭" },
  { code: "CM", name: "Cameroon", nameAz: "Kamerun", dial: "+237", flag: "🇨🇲" },
  { code: "CA", name: "Canada", nameAz: "Kanada", dial: "+1", flag: "🇨🇦" },
  { code: "CL", name: "Chile", nameAz: "Çili", dial: "+56", flag: "🇨🇱" },
  { code: "CN", name: "China", nameAz: "Çin", dial: "+86", flag: "🇨🇳" },
  { code: "CO", name: "Colombia", nameAz: "Kolumbiya", dial: "+57", flag: "🇨🇴" },
  { code: "CR", name: "Costa Rica", nameAz: "Kosta-Rika", dial: "+506", flag: "🇨🇷" },
  { code: "HR", name: "Croatia", nameAz: "Xorvatiya", dial: "+385", flag: "🇭🇷" },
  { code: "CU", name: "Cuba", nameAz: "Kuba", dial: "+53", flag: "🇨🇺" },
  { code: "CY", name: "Cyprus", nameAz: "Kipr", dial: "+357", flag: "🇨🇾" },
  { code: "CZ", name: "Czech Republic", nameAz: "Çexiya", dial: "+420", flag: "🇨🇿" },
  { code: "DK", name: "Denmark", nameAz: "Danimarka", dial: "+45", flag: "🇩🇰" },
  { code: "DO", name: "Dominican Republic", nameAz: "Dominikan Resp.", dial: "+1", flag: "🇩🇴" },
  { code: "EC", name: "Ecuador", nameAz: "Ekvador", dial: "+593", flag: "🇪🇨" },
  { code: "EG", name: "Egypt", nameAz: "Misir", dial: "+20", flag: "🇪🇬" },
  { code: "EE", name: "Estonia", nameAz: "Estoniya", dial: "+372", flag: "🇪🇪" },
  { code: "ET", name: "Ethiopia", nameAz: "Efiopiya", dial: "+251", flag: "🇪🇹" },
  { code: "FI", name: "Finland", nameAz: "Finlandiya", dial: "+358", flag: "🇫🇮" },
  { code: "FR", name: "France", nameAz: "Fransa", dial: "+33", flag: "🇫🇷" },
  { code: "GE", name: "Georgia", nameAz: "Gürcüstan", dial: "+995", flag: "🇬🇪" },
  { code: "DE", name: "Germany", nameAz: "Almaniya", dial: "+49", flag: "🇩🇪" },
  { code: "GH", name: "Ghana", nameAz: "Qana", dial: "+233", flag: "🇬🇭" },
  { code: "GR", name: "Greece", nameAz: "Yunanıstan", dial: "+30", flag: "🇬🇷" },
  { code: "GT", name: "Guatemala", nameAz: "Qvatemala", dial: "+502", flag: "🇬🇹" },
  { code: "HK", name: "Hong Kong", nameAz: "Honkonq", dial: "+852", flag: "🇭🇰" },
  { code: "HU", name: "Hungary", nameAz: "Macarıstan", dial: "+36", flag: "🇭🇺" },
  { code: "IS", name: "Iceland", nameAz: "İslandiya", dial: "+354", flag: "🇮🇸" },
  { code: "IN", name: "India", nameAz: "Hindistan", dial: "+91", flag: "🇮🇳" },
  { code: "ID", name: "Indonesia", nameAz: "İndoneziya", dial: "+62", flag: "🇮🇩" },
  { code: "IR", name: "Iran", nameAz: "İran", dial: "+98", flag: "🇮🇷" },
  { code: "IQ", name: "Iraq", nameAz: "İraq", dial: "+964", flag: "🇮🇶" },
  { code: "IE", name: "Ireland", nameAz: "İrlandiya", dial: "+353", flag: "🇮🇪" },
  { code: "IL", name: "Israel", nameAz: "İsrail", dial: "+972", flag: "🇮🇱" },
  { code: "IT", name: "Italy", nameAz: "İtaliya", dial: "+39", flag: "🇮🇹" },
  { code: "JP", name: "Japan", nameAz: "Yaponiya", dial: "+81", flag: "🇯🇵" },
  { code: "JO", name: "Jordan", nameAz: "İordaniya", dial: "+962", flag: "🇯🇴" },
  { code: "KZ", name: "Kazakhstan", nameAz: "Qazaxıstan", dial: "+7", flag: "🇰🇿" },
  { code: "KE", name: "Kenya", nameAz: "Keniya", dial: "+254", flag: "🇰🇪" },
  { code: "KW", name: "Kuwait", nameAz: "Küveyt", dial: "+965", flag: "🇰🇼" },
  { code: "KG", name: "Kyrgyzstan", nameAz: "Qırğızıstan", dial: "+996", flag: "🇰🇬" },
  { code: "LV", name: "Latvia", nameAz: "Latviya", dial: "+371", flag: "🇱🇻" },
  { code: "LB", name: "Lebanon", nameAz: "Livan", dial: "+961", flag: "🇱🇧" },
  { code: "LY", name: "Libya", nameAz: "Liviya", dial: "+218", flag: "🇱🇾" },
  { code: "LT", name: "Lithuania", nameAz: "Litva", dial: "+370", flag: "🇱🇹" },
  { code: "LU", name: "Luxembourg", nameAz: "Lüksemburq", dial: "+352", flag: "🇱🇺" },
  { code: "MK", name: "Macedonia", nameAz: "Şimali Makedoniya", dial: "+389", flag: "🇲🇰" },
  { code: "MY", name: "Malaysia", nameAz: "Malayziya", dial: "+60", flag: "🇲🇾" },
  { code: "MT", name: "Malta", nameAz: "Malta", dial: "+356", flag: "🇲🇹" },
  { code: "MX", name: "Mexico", nameAz: "Meksika", dial: "+52", flag: "🇲🇽" },
  { code: "MD", name: "Moldova", nameAz: "Moldova", dial: "+373", flag: "🇲🇩" },
  { code: "MC", name: "Monaco", nameAz: "Monako", dial: "+377", flag: "🇲🇨" },
  { code: "MN", name: "Mongolia", nameAz: "Monqolustan", dial: "+976", flag: "🇲🇳" },
  { code: "ME", name: "Montenegro", nameAz: "Monteneqro", dial: "+382", flag: "🇲🇪" },
  { code: "MA", name: "Morocco", nameAz: "Mərakeş", dial: "+212", flag: "🇲🇦" },
  { code: "NP", name: "Nepal", nameAz: "Nepal", dial: "+977", flag: "🇳🇵" },
  { code: "NL", name: "Netherlands", nameAz: "Niderland", dial: "+31", flag: "🇳🇱" },
  { code: "NZ", name: "New Zealand", nameAz: "Yeni Zelandiya", dial: "+64", flag: "🇳🇿" },
  { code: "NG", name: "Nigeria", nameAz: "Nigeriya", dial: "+234", flag: "🇳🇬" },
  { code: "NO", name: "Norway", nameAz: "Norveç", dial: "+47", flag: "🇳🇴" },
  { code: "OM", name: "Oman", nameAz: "Oman", dial: "+968", flag: "🇴🇲" },
  { code: "PK", name: "Pakistan", nameAz: "Pakistan", dial: "+92", flag: "🇵🇰" },
  { code: "PS", name: "Palestine", nameAz: "Fələstin", dial: "+970", flag: "🇵🇸" },
  { code: "PA", name: "Panama", nameAz: "Panama", dial: "+507", flag: "🇵🇦" },
  { code: "PE", name: "Peru", nameAz: "Peru", dial: "+51", flag: "🇵🇪" },
  { code: "PH", name: "Philippines", nameAz: "Filippin", dial: "+63", flag: "🇵🇭" },
  { code: "PL", name: "Poland", nameAz: "Polşa", dial: "+48", flag: "🇵🇱" },
  { code: "PT", name: "Portugal", nameAz: "Portuqaliya", dial: "+351", flag: "🇵🇹" },
  { code: "QA", name: "Qatar", nameAz: "Qətər", dial: "+974", flag: "🇶🇦" },
  { code: "RO", name: "Romania", nameAz: "Rumıniya", dial: "+40", flag: "🇷🇴" },
  { code: "RU", name: "Russia", nameAz: "Rusiya", dial: "+7", flag: "🇷🇺" },
  { code: "SA", name: "Saudi Arabia", nameAz: "Səudiyyə Ərəbistanı", dial: "+966", flag: "🇸🇦" },
  { code: "RS", name: "Serbia", nameAz: "Serbiya", dial: "+381", flag: "🇷🇸" },
  { code: "SG", name: "Singapore", nameAz: "Sinqapur", dial: "+65", flag: "🇸🇬" },
  { code: "SK", name: "Slovakia", nameAz: "Slovakiya", dial: "+421", flag: "🇸🇰" },
  { code: "SI", name: "Slovenia", nameAz: "Sloveniya", dial: "+386", flag: "🇸🇮" },
  { code: "ZA", name: "South Africa", nameAz: "Cənubi Afrika", dial: "+27", flag: "🇿🇦" },
  { code: "KR", name: "South Korea", nameAz: "Cənubi Koreya", dial: "+82", flag: "🇰🇷" },
  { code: "ES", name: "Spain", nameAz: "İspaniya", dial: "+34", flag: "🇪🇸" },
  { code: "LK", name: "Sri Lanka", nameAz: "Şri-Lanka", dial: "+94", flag: "🇱🇰" },
  { code: "SE", name: "Sweden", nameAz: "İsveç", dial: "+46", flag: "🇸🇪" },
  { code: "CH", name: "Switzerland", nameAz: "İsveçrə", dial: "+41", flag: "🇨🇭" },
  { code: "SY", name: "Syria", nameAz: "Suriya", dial: "+963", flag: "🇸🇾" },
  { code: "TW", name: "Taiwan", nameAz: "Tayvan", dial: "+886", flag: "🇹🇼" },
  { code: "TJ", name: "Tajikistan", nameAz: "Tacikistan", dial: "+992", flag: "🇹🇯" },
  { code: "TZ", name: "Tanzania", nameAz: "Tanzaniya", dial: "+255", flag: "🇹🇿" },
  { code: "TH", name: "Thailand", nameAz: "Tailand", dial: "+66", flag: "🇹🇭" },
  { code: "TN", name: "Tunisia", nameAz: "Tunis", dial: "+216", flag: "🇹🇳" },
  { code: "TR", name: "Turkey", nameAz: "Türkiyə", dial: "+90", flag: "🇹🇷" },
  { code: "TM", name: "Turkmenistan", nameAz: "Türkmənistan", dial: "+993", flag: "🇹🇲" },
  { code: "UG", name: "Uganda", nameAz: "Uqanda", dial: "+256", flag: "🇺🇬" },
  { code: "UA", name: "Ukraine", nameAz: "Ukrayna", dial: "+380", flag: "🇺🇦" },
  { code: "AE", name: "United Arab Emirates", nameAz: "BƏƏ", dial: "+971", flag: "🇦🇪" },
  { code: "GB", name: "United Kingdom", nameAz: "Böyük Britaniya", dial: "+44", flag: "🇬🇧" },
  { code: "US", name: "United States", nameAz: "ABŞ", dial: "+1", flag: "🇺🇸" },
  { code: "UY", name: "Uruguay", nameAz: "Uruqvay", dial: "+598", flag: "🇺🇾" },
  { code: "UZ", name: "Uzbekistan", nameAz: "Özbəkistan", dial: "+998", flag: "🇺🇿" },
  { code: "VE", name: "Venezuela", nameAz: "Venesuela", dial: "+58", flag: "🇻🇪" },
  { code: "VN", name: "Vietnam", nameAz: "Vyetnam", dial: "+84", flag: "🇻🇳" },
  { code: "YE", name: "Yemen", nameAz: "Yəmən", dial: "+967", flag: "🇾🇪" },
  { code: "ZW", name: "Zimbabwe", nameAz: "Zimbabve", dial: "+263", flag: "🇿🇼" },
];

export const DEFAULT_COUNTRY = COUNTRIES[0]; // Azerbaijan

export function findCountryByCode(code) {
  if (!code) return DEFAULT_COUNTRY;
  return COUNTRIES.find((c) => c.code === code) || DEFAULT_COUNTRY;
}
